import { FC, useMemo } from 'react';
import { formatValueAsString } from '../../../utils/helpers';

interface ICoverageProps {
	vesselsCount?: number | null;
	calculatedVesselsCount?: number | null;
	coveragePercentage?: number | null;
}

const Coverage: FC<ICoverageProps> = ({ vesselsCount, calculatedVesselsCount, coveragePercentage }) => {
	const options = useMemo(() => ({ minimumFractionDigits: 1, maximumFractionDigits: 2 }), []);

	return (
		<div className="absolute right-0 top-7 pr-2">
			<span className="text-medium text-msi-darkgrey-color-900">
				{`(Data for ${calculatedVesselsCount} vessels out of ${vesselsCount} selected - ${formatValueAsString(coveragePercentage, options, '', '', '%')})`}
			</span>
		</div>
	);
};

export default Coverage;
